import React, { useCallback } from 'react';
import Button from '@mui/material/Button';
import theme from '@wavetrak/theme';
import classNames from 'classnames';
import config from 'config';
import Triangle from 'components/Icons/Triangle';
import { SpotDetails } from 'types/spot';

import { trackEvent } from '@surfline/web-common';
import styles from './LiveCamButton.module.scss';

const LiveCamButton = ({
  className,
  dataTestId,
  spot,
  size,
}: {
  className?: string;
  dataTestId?: string;
  spot?: SpotDetails;
  size?: 'small' | 'medium' | 'large';
}) => {
  const handleClick = useCallback(() => {
    trackEvent('Clicked Subscribe CTA', {
      screenName: 'Spot',
      CTAText: 'View live',
      location: 'Yesterday Rewind button View Live Button',
      spotId: spot?._id,
      spotName: spot?.name,
      subregionId: spot?.subregion?._id,
    });
    window.location.href = `${config.surflineHost}/upgrade`;
  }, [spot]);

  return (
    <Button
      variant="primary"
      color="primary"
      className={classNames(styles.goLiveButton, className)}
      disableRipple
      disableFocusRipple
      disableTouchRipple
      data-testid={dataTestId}
      onClick={handleClick}
      size={size}
    >
      <Triangle fill={theme.palette.secondary.main} />
      View Live
    </Button>
  );
};

export default LiveCamButton;
